































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TabelaDePreco } from '@/models'

@Component
export default class SeletorDeTabelasDePrecoComParcelas extends Vue {
	@Prop({ type: Array, default: () => [] }) tabelas!: TabelaDePreco[]
	@Prop({ type: Array, default: () => [] }) value!: TabelaDePreco[]
	@Prop({ type: Boolean, default: false }) singleSelect!: boolean
	@Prop({ type: Object, default: () => ({}) }) parcelas!: Record<string, number>

	estaSelecionada(tabela: TabelaDePreco) {
		return this.value.some(selecionada => selecionada.id === tabela.id)
	}

	parcelasDaTabela(tabela: TabelaDePreco) {
		return this.parcelas[tabela.id] || 1
	}

	alternarSelecao(tabela: TabelaDePreco) {
		const novaSelecao = this.estaSelecionada(tabela)
			? this.value.filter(selecionada => selecionada.id !== tabela.id)
			: this.singleSelect ? [tabela] : [...this.value, tabela]

		this.$emit('input', novaSelecao)
	}

	alterarParcelas(tabela: TabelaDePreco, delta: number) {
		this.definirParcelas(tabela, this.parcelasDaTabela(tabela) + delta)
	}

	onAlterarQuantidade(tabela: TabelaDePreco, valor: string) {
		this.definirParcelas(tabela, parseInt(valor, 10))
	}

	definirParcelas(tabela: TabelaDePreco, valor: number) {
		const parcelasValidadas = Number.isFinite(valor) && valor >= 1 ? Math.trunc(valor) : 1
		this.$emit('update:parcelas', { ...this.parcelas, [tabela.id]: parcelasValidadas })
	}
}
